import { create } from 'zustand';

/**
 * Post Error Store
 * Manages regeneration errors for individual posts
 */
export const usePostErrorStore = create((set) => ({
  // State: Map of postId -> error message
  postErrors: {},

  // Actions
  setPostError: (postId, error) =>
    set((state) => ({
      postErrors: {
        ...state.postErrors,
        [postId]: error,
      },
    })),

  clearPostError: (postId) =>
    set((state) => {
      const { [postId]: _, ...rest } = state.postErrors;
      return { postErrors: rest };
    }),

  getPostError: (postId) => {
    const state = usePostErrorStore.getState();
    return state.postErrors[postId] || null;
  },

  clearAllPostErrors: () => set({ postErrors: {} }),
}));

export default usePostErrorStore;
